import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { throwIfAlreadyLoaded } from './module-import-guard';
import { TranslateModule } from '@ngx-translate/core';
import { MainComponent } from './components/main/main.component';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SharedModule } from '../shared/shared.module';
import { PaceCoreModule } from '@evorait/pace-core';
import { AppHeaderComponent } from './components/header/app-header.component';
import { WeeklyWorkTimeComponent } from './components/header/weekly-work-time/weekly-work-time.component';
import { PaceInformationComponent } from './components/header/pace-information/pace-information.component';
import { ReturnMaterialComponent } from './components/header/return-material/return-material.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        FontAwesomeModule,
        PopoverModule,
        ModalModule,
        SharedModule,
        PaceCoreModule.forChild(),
    ],
    declarations: [
        MainComponent,
        AppHeaderComponent,
        WeeklyWorkTimeComponent,
        PaceInformationComponent,
        ReturnMaterialComponent,
    ],
    exports: [TranslateModule],
    providers: [],
})
export class CoreModule {
    public constructor(
        @Optional()
        @SkipSelf()
        parentModule: CoreModule,
    ) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
